import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full justify-between" }
const _hoisted_2 = { class: "px-[34px] w-full" }
const _hoisted_3 = { class: "flex justify-center w-full font-sourcesanspro-semibold text-l2" }
const _hoisted_4 = { class: "relative mb-4" }
const _hoisted_5 = ["validation-schema"]
const _hoisted_6 = { class: "px-[34px] mb-[34px]" }
const _hoisted_7 = { class: "flex w-full items-center justify-center" }

import { onBeforeMount, ref, watch } from 'vue';
import { Device } from '@capacitor/device';
import router from '@/router';
import { useRoute } from 'vue-router';
import { IonButton, IonContent, IonIcon } from '@ionic/vue';
import * as Yup from 'yup';
import { chevronBackOutline } from 'ionicons/icons';
import i18n from '@/i18n';

import hexRgb from 'hex-rgb';
import rgbHex from 'rgb-hex';
import TextInput from '@/shared/components/sign-up-forms/TextInput.vue';
import TopBar from '@/shared/components/TopBar.vue';
import useCustomForm from '@/shared/composables/useCustomForm';
import useUtils from '@/shared/composables/useUtils';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'ProfilePasswordResetStepTwoPage',
  setup(__props) {

const { calculateShade } = useUtils();
const primary_color = window.primary_color;
const primaryRgb = hexRgb(window.primary_color, { format: 'array' });
const primaryShade = '#' + rgbHex(calculateShade(primaryRgb.toString(), 0.2));

// Using yup to generate a validation schema
const schema = Yup.object().shape({
	password: Yup.string().min(6).required(),
	password_confirmation: Yup.string()
		.required()
		.oneOf([Yup.ref('password')], i18n.global.t('profile.password_reset.errors.passwords_do_not_match')),
});

// Get uuid
const route = useRoute();
const userUuid = route.query.uuid?.toString();
const token = route.params.id;

const _getUUID = (): string => {
	const name = 'uuid';
	const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
	const results = regex.exec(decodeURIComponent(window.location.href));
	if (!results) {
		return '';
	}
	if (!results[2]) {
		return '';
	}
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const uuid = userUuid || _getUUID();
const additionalData = ref({});

onBeforeMount(async () => {
	const deviceInfo = await Device.getInfo();
	additionalData.value = {
		token,
		uuid,
		device_name: `${deviceInfo.model}${deviceInfo.name ? ' ' + deviceInfo.name : ''}`,
	};
});

// useCustomForm
const { isFormValid, isSuccess, onSubmit, onInputChange } = useCustomForm(schema, '/auth/change-password', 'post', 'profile.password_reset.messages.password_changed', 'profile.password_reset.errors.error', 5000, additionalData);

watch(isSuccess, async () => {
	await router.push('/dashboard');
});

// Go back
const goBack = () => {
	router.back();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), {
    style: _normalizeStyle(`background: linear-gradient(${_unref(primary_color)}, ${primaryShade});`)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TopBar, null, {
            left: _withCtx(() => [
              _createVNode(_unref(IonButton), {
                class: "w-[35px] h-[35px] text-black ion-no-padding ion-no-margin hover:bg-white hover:rounded-full",
                shape: "round",
                onClick: goBack
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(chevronBackOutline),
                    class: "ion-no-padding ion-no-margin text-black mr-[2px]"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            center: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('profile.password_reset.title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", {
              id: "changePasswordForm",
              "validation-schema": _unref(schema),
              onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
            }, [
              _createVNode(TextInput, {
                "wrapper-class": "flex flex-wrap justify-left item-center mb-2 border border-solid focus-within:background-white-15",
                name: "password",
                type: "password",
                placeholder: _ctx.$t('profile.password_reset.new_password') + '*',
                onInputChanged: _unref(onInputChange)
              }, null, 8, ["placeholder", "onInputChanged"]),
              _createVNode(TextInput, {
                "wrapper-class": "flex flex-wrap justify-left item-center mb-2 border border-solid focus-within:background-white-15",
                name: "password_confirmation",
                type: "password",
                placeholder: _ctx.$t('profile.password_reset.confirm_password') + '*',
                onInputChanged: _unref(onInputChange)
              }, null, 8, ["placeholder", "onInputChanged"])
            ], 40, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(IonButton), {
            class: "w-full hover:bg-white hover:rounded-full",
            disabled: !_unref(isFormValid),
            expand: "full",
            form: "changePasswordForm",
            size: "large",
            shape: "round",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('profile.password_reset.change_password')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})